<template lang="pug">
  .container.grid-lg.py-2
    form.list-filters(@submit.prevent='listar')
      .columns.align-center
        .column.columns.align-center
          .column.col-4.form-group
            small {{ 'perfil.descricao' | tModel }}
            input.input-sm.razao-social.form-input(type='search' v-model='q.descricao_cont')
          .column.col-auto.form-group.nowrap.mt-2
            label.form-radio.form-inline.white.small
              input(type='radio' v-model='q.ativo_eq', :value='true')
              i.form-icon
              |  Ativo
            label.form-radio.form-inline.white.small
              input(type='radio' v-model='q.ativo_eq', :value='false')
              i.form-icon
              |  Inativo
          .column.col-auto.text-right
            button.btn.btn-link.tooltip.tooltip-bottom(type='submit', :data-tooltip="$i18n.t('views.buttons.filter.label')")
              i.fa.fa-search.fa-lg
        .column.col-auto
          router-link.btn.btn-action.s-circle.tooltip.tooltip-bottom(
            :to="{name: 'app.sistema.perfis.new'}" 
            data-tooltip='Novo' 
            v-acl:allowed.admin.sistema.perfis.create
          )
            i.icon.icon-plus
    load-manager(:status='status')
      list-manager(:status='status', :count='list.length')
        .columns
          .column.col-6.col-md-12(v-for='p in list' :key='p.id')
            .my-2
              list-item-card
                .h6 {{ p.descricao }}
                .columns.mt-2
                  .column
                    .tooltip.abbr(:data-tooltip="'perfil.created_at' | tModel") {{ p.created_at | date }}
                  .column.text-right
                    .tooltip.abbr(:data-tooltip="'perfil.updated_at' | tModel") {{ p.updated_at | date }}
                .text-right(slot='footer')
                  router-link.btn.btn-link.tooltip(
                    :to="{name: 'app.sistema.perfis.edit', params: {id: p.id}}",
                    :data-tooltip="$i18n.t('views.buttons.edit.label')"
                    v-acl:allowed.admin.sistema.perfis.update
                  )
                    btn-icon.fa-lg(name='edit')
    .text-center(v-if='pages > 1')
      btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
export default {
  vuex: {
    'sistema/perfis': {
      state: ['list', 'status', 'page', 'pages', 'query', 'count'],
      getters: ['loading'],
      mutations: ['setQuery', 'setPage'],
      actions: ['fetchList', 'prevPage', 'nextPage', 'goPage'],
    },
  },
  data() {
    return {
      q: {
        descricao_cont: '',
        ativo_eq: true,
      },
    }
  },
  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
